import { CheckCircle } from "lucide-react";

export default function TransportationWhyChooseUs() {
    const points = [
        "Trusted by Hyderabad's top companies",
        "Diverse fleet from 4 to 42 seaters",
        "100% tracked and compliant vehicles",
        "Experienced professional chauffeurs",
        "Custom solutions for your needs",
        "Punctual and reliable service"
    ];

    return (
        <section className="bg-gradient-to-br from-stone-50 to-stone-100 py-10 md:py-14 px-4 sm:px-6 lg:px-12">
            <div className="w-[95%] mx-auto text-center">
                <div className="mb-4 md:mb-8">
                    <h2 className="text-[22px] md:text-2xl lg:text-3xl font-semibold text-gray-800">
                        Why Choose <span className="text-blue-800 relative">
                            PVR Cabs
                        </span>
                    </h2>

                    <div className="space-y-2 md:space-y-3 mt-2 md:mt-4">
                        <p className="text-gray-70 w-[95%] md:max-w-4xl mx-auto text-sm md:text-sm lg:text-base leading-relaxed">
                            PVR Cabs is Hyderabad's most trusted employee transportation partner-serving leading MNCs and BPOs with dependable, secure, and on-time mobility solutions.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-4 text-left w-[90%] md:max-w-5xl mx-auto">
                    {points.map((point, index) => (
                        <div 
                            key={index} 
                            className="flex items-start lg:items-center space-x-3 bg-white p-2.5 md:p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 border border-stone-200"
                        >
                            <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0" />
                            <span className="text-gray-800 text-xs md:text-sm font-medium">{point}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}